import { createSlice } from '@reduxjs/toolkit';

import {
  register,
  logIn,
  logOut,
  getCurrentUser,
  updateUser,
  getVerifyEmailUser,
  updateUserLogo,
  updateUserBagPicture,
  deleteUserBagPicture,
  deleteUserLogo,
  sendVerifyEmailUser,
  finalOnBoard,
  refreshTokenThunk,
  updatePassword,
} from './operations';

const initialState = {
  user: {
    id: null,
    name: null,
    email: null,
    address: null,
    merchant: null,
  },


  access: {
    token: null,
    refreshToken: null,
  },
  isOnBoard: false,
  isBoardStep: 1,
  isLoggedIn: false,
  isFetchingCurrentUser: true,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // ✅ Додаємо цей ред'юсер
    setAccess(state, action) {
      state.access.token = action.payload.token;
      state.access.refreshToken = action.payload.refreshToken;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(register.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.access.token = action.payload.access.token;
        state.access.refreshToken = action.payload.access.refreshToken;
        state.isLoggedIn = true;
        state.isOnBoard = true;
      })
      .addCase(logIn.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.access.token = action.payload.access.token;
        state.access.refreshToken = action.payload.access.refreshToken;
        state.isLoggedIn = true;
        state.isOnBoard = true;
      })
      .addCase(logOut.fulfilled, state => {
        console.log('sdfsdfsdf :>> ');
        state.access.token = null;
        state.access.refreshToken = null;
        state.isLoggedIn = false;
      })
.addCase(logOut.rejected, state => {
  state.access.token = null;
  state.access.refreshToken = null;
  state.isLoggedIn = false;
})

      .addCase(refreshTokenThunk.fulfilled, (state, action) => {
        state.access.token = action.payload.access.token;
        state.access.refreshToken = action.payload.access.refreshToken;
      })
      .addCase(finalOnBoard.fulfilled, state => {

        state.isOnBoard = false;
      })
      .addCase(getCurrentUser.pending, state => {
        state.isFetchingCurrentUser = true;
      })
      .addCase(updateUserLogo.pending, state => {
        state.isFetchingCurrentUser = true;
      })
      .addCase(updateUserBagPicture.pending, state => {
        state.isFetchingCurrentUser = true;
      })
      .addCase(deleteUserBagPicture.pending, state => {

        state.isFetchingCurrentUser = true;
      })
      .addCase(deleteUserLogo.pending, state => {

        state.isFetchingCurrentUser = true;

      })

      .addCase(getCurrentUser.fulfilled, (state, action) => {

        state.user = action.payload;
        state.isLoggedIn = true;
        state.isFetchingCurrentUser = false;

      })
      .addCase(getCurrentUser.rejected, state => {
        state.isFetchingCurrentUser = false;
      })

      .addCase(updateUserLogo.fulfilled, (state, action) => {

        state.user.merchant.logo = action.payload;
        state.isFetchingCurrentUser = false;
      })
      .addCase(sendVerifyEmailUser.fulfilled, (state, action) => {

        action?.code && delete state.user.unconfirmed_email;

      })

      .addCase(updatePassword.pending, state => {
        state.isFetchingCurrentUser = true;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        // паролі змінені успішно, користувача лишаємо в системі
        if (action.payload?.access) {
          state.access.token = action.payload.access.token;
          state.access.refreshToken = action.payload.access.refreshToken;

        }
        state.isFetchingCurrentUser = false;
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.error = action.payload || 'Failed to change password';
        state.isFetchingCurrentUser = false;
      })

      .addCase(updateUserBagPicture.fulfilled, (state, action) => {
        state.user.merchant.bag_picture = action.payload;
        state.isFetchingCurrentUser = false;
      })
      .addCase(deleteUserBagPicture.fulfilled, (state, action) => {
        delete state.user.merchant.bag_picture; // Повністю видаляємо ключ

        state.isFetchingCurrentUser = false;
      })
      .addCase(deleteUserLogo.fulfilled, state => {

        delete state.user.merchant.logo; // Повністю видаляємо ключ
        state.isFetchingCurrentUser = false;
      })

      .addCase(updateUser.fulfilled, (state, action) => {
        console.log('action.payload; :>> ', action.payload);
        console.log('state.user; :>> ', state.user);
        state.user = action.payload;
      })

      .addCase(getVerifyEmailUser.fulfilled, (state, action) => {
        state.user.verify = action.payload;
      });
  },
});
export const { setAccess } = authSlice.actions;
export const authReducer = authSlice.reducer;
